import { useQueryParam, withDefault } from 'use-query-params';
import { StringParam } from '@app/utils/use-query-params.utils';

export const useSrcUrlQueryParam = () => useQueryParam('srcUrl', withDefault(StringParam, ''));
